@if (mobileMode) {
  <div class="position-relative">
    <a (click)="toggleMessages()">
      <div class="position-relative d-inline-block">
        <shared-feather-icons [icon]="'mail'"></shared-feather-icons>
        @if (totalCount > 0) {
          <span
            class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
            style="font-size: 0.6rem; padding: 0.2rem 0.4rem"
          >
            {{ totalCount > 99 ? '+99' : totalCount }}
          </span>
        }
      </div>
      <span>
        {{ 'profile.messages' | translate }}
      </span>
    </a>

    @if (showMessages) {
      <div
        class="mobile-overlay"
        (click)="closeMessages()"
        (touchmove)="$event.preventDefault()"
      ></div>
    }

    @if (showMessages) {
      <div
        [class]="'position-fixed card shadow-lg messages-panel-mobile'"
        (touchmove)="$event.stopPropagation()"
      >
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="mb-0 fw-semibold">
              {{ 'profile.messages' | translate }}
            </h6>
            <div class="d-flex align-items-center gap-2">
              <button
                class="btn btn-sm p-0 text-muted"
                (click)="closeMessages()"
                type="button"
                style="border: none; background: none"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        @if (isLoading && messages.length === 0) {
          <div class="card-body text-center py-4">
            <div
              class="spinner-border spinner-border-sm text-primary"
              role="status"
            >
              <span class="visually-hidden">{{
                'words.loading' | translate
              }}</span>
            </div>
          </div>
        }

        @if (messages.length > 0) {
          <div
            class="card-body p-0 overflow-auto"
            style="max-height: 300px"
            (scroll)="onScroll($event)"
            (touchmove)="$event.stopPropagation()"
          >
            @for (
              message of messages;
              track trackByMessageId($index, message)
            ) {
              <div
                class="border-bottom px-3 py-3 message-item cursor-pointer"
                (click)="goToMessage(message)"
              >
                <div class="d-flex align-items-start">
                  <div class="flex-shrink-0 me-3">
                    <div
                      class="bg-primary rounded-circle d-flex align-items-center justify-content-center"
                      style="width: 40px; height: 40px"
                    >
                      <i class="fa fa-user text-white"></i>
                    </div>
                  </div>

                  <div class="flex-grow-1 min-width-0">
                    <div
                      class="d-flex justify-content-between align-items-center mb-1"
                    >
                      @if (isAdminView()) {
                        <h6 class="mb-0 fw-semibold small">
                          {{
                            getParticipantLabel(
                              message.fromId,
                              message.fromType
                            )
                          }}
                          →
                          {{
                            getParticipantLabel(message.toId, message.toType)
                          }}
                        </h6>
                      }
                      @if (!isAdminView()) {
                        <h6 class="mb-0 text-truncate fw-semibold small">
                          {{ getSenderName(message) }}
                        </h6>
                      }
                      <small class="text-muted flex-shrink-0 ms-2">
                        {{ getTimeAgo(message.createdAt) }}
                      </small>
                    </div>

                    <p class="mb-0 fw-medium text-truncate small">
                      {{ message.subject }}
                    </p>
                  </div>

                  <div class="flex-shrink-0 ms-2">
                    <button
                      class="btn btn-link p-0 text-muted mark-read-btn"
                      (click)="markAsRead(message); $event.stopPropagation()"
                      [title]="'players.chats.markAsRead' | translate"
                      type="button"
                    >
                      <i class="fa fa-check"></i>
                    </button>
                  </div>
                </div>
              </div>
            }

            @if (isLoading && messages.length > 0) {
              <div class="text-center py-3">
                <div
                  class="spinner-border spinner-border-sm text-primary"
                  role="status"
                >
                  <span class="visually-hidden">{{
                    'players.chats.conversation.loadingMore' | translate
                  }}</span>
                </div>
              </div>
            }
          </div>
        }

        @if (!isLoading && messages.length === 0) {
          <div class="card-body text-center py-5">
            <i
              class="fa fa-envelope text-muted mb-3"
              style="font-size: 48px"
            ></i>
            <p class="text-muted mb-3">
              {{ 'profile.messageBox.noNewMessages' | translate }}
            </p>
            <button
              class="btn btn-link text-decoration-none small"
              (click)="viewAllMessages()"
            >
              {{ 'profile.messageBox.viewAllMessages' | translate }}
            </button>
          </div>
        }
      </div>
    }
  </div>
}

@if (!mobileMode) {
  <div
    class="position-relative"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
  >
    <button
      class="btn p-0 position-relative message-trigger"
      type="button"
      (click)="toggleMessages()"
    >
        <svg>
          <use href="assets/svg/icon-sprite.svg#stroke-email"></use>
        </svg>
      @if (totalCount > 0) {
        <span
          class="position-absolute top-0 start-50 translate-middle-y badge rounded-pill bg-danger d-flex align-items-center justify-content-center text-nowrap px-2 badge-text"
        >
          {{ totalCount > 99 ? '+99' : totalCount }}
        </span>
      }
    </button>

    @if (showMessages) {
      <div
        class="mobile-overlay d-block d-md-none"
        (click)="closeMessages()"
        (touchmove)="$event.preventDefault()"
      ></div>
    }

    <div
      [class]="
        'position-absolute card shadow-lg messages-panel ' +
        (showMessages ? 'show' : 'hide')
      "
      (mouseenter)="onMouseEnter()"
      (mouseleave)="onMouseLeave()"
      (touchmove)="$event.stopPropagation()"
    >
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="mb-0 fw-semibold">{{ 'profile.messages' | translate }}</h6>
          <div class="d-flex align-items-center gap-2">
            <button
              class="btn btn-sm p-0 text-muted"
              (click)="closeMessages()"
              type="button"
              style="border: none; background: none"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      @if (isLoading && messages.length === 0) {
        <div class="card-body text-center py-4">
          <div
            class="spinner-border spinner-border-sm text-primary"
            role="status"
          >
            <span class="visually-hidden">{{
              'words.loading' | translate
            }}</span>
          </div>
        </div>
      }

      @if (messages.length > 0) {
        <div
          class="card-body p-0 overflow-auto"
          style="max-height: 300px"
          (scroll)="onScroll($event)"
          (touchmove)="$event.stopPropagation()"
        >
          @for (message of messages; track trackByMessageId($index, message)) {
            <div
              class="border-bottom px-3 py-3 message-item cursor-pointer"
              (click)="goToMessage(message)"
            >
              <div class="d-flex align-items-start">
                <div class="flex-shrink-0 me-3">
                  <div
                    class="bg-primary rounded-circle d-flex align-items-center justify-content-center"
                    style="width: 40px; height: 40px"
                  >
                    <i class="fa fa-user text-white"></i>
                  </div>
                </div>

                <div class="flex-grow-1 min-width-0">
                  <div
                    class="d-flex justify-content-between align-items-center mb-1"
                  >
                    @if (isAdminView()) {
                      <h6 class="mb-0 fw-semibold small">
                        {{
                          getParticipantLabel(message.fromId, message.fromType)
                        }}
                        →
                        {{ getParticipantLabel(message.toId, message.toType) }}
                      </h6>
                    }
                    @if (!isAdminView()) {
                      <h6 class="mb-0 text-truncate fw-semibold small">
                        {{ getSenderName(message) }}
                      </h6>
                    }
                    <small class="flex-shrink-0 ms-2">
                      {{ getTimeAgo(message.createdAt) }}
                    </small>
                  </div>

                  <p class="mb-0 fw-medium text-truncate small">
                    {{ message.subject }}
                  </p>
                </div>

                <div class="flex-shrink-0 ms-2">
                  <button
                    class="btn btn-link p-0 mark-read-btn"
                    (click)="markAsRead(message); $event.stopPropagation()"
                    [title]="'players.chats.markAsRead' | translate"
                    type="button"
                  >
                    <i class="fa fa-check"></i>
                  </button>
                </div>
              </div>
            </div>
          }

          @if (isLoading && messages.length > 0) {
            <div class="text-center py-3">
              <div
                class="spinner-border spinner-border-sm text-primary"
                role="status"
              >
                <span class="visually-hidden">{{
                  'players.chats.conversation.loadingMore' | translate
                }}</span>
              </div>
            </div>
          }
        </div>
      }

      @if (!isLoading && messages.length === 0) {
        <div class="card-body text-center py-5">
          <i class="fa fa-envelope mb-3" style="font-size: 48px"></i>
          <p class="mb-3">
            {{ 'profile.messageBox.noNewMessages' | translate }}
          </p>
          <button
            class="btn btn-link text-decoration-none small"
            (click)="viewAllMessages()"
          >
            {{ 'profile.messageBox.viewAllMessages' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
}
